import React from 'react';
import ArchiveDashboard from '../../features/Dashboard/components/Archive/components/ArchiveDashboard/ArchiveDashboard';

const Archive = () => {
  return <ArchiveDashboard />;
};

export default Archive;
